import { memo } from 'react'
import { OrderOtherWrap, TitleWrap } from '../styles'
import { UserOrdersTabs } from './Tabs'
import { HideOtherPairs } from 'components/HideOtherPairs'

export const UserOrdersTop = memo(() => {
  return (
    <TitleWrap>
      <UserOrdersTabs />
      <OrderOtherWrap>
        <HideOtherPairs />
      </OrderOtherWrap>
    </TitleWrap>
  )
})
